import styled from 'styled-components';

export const SliderSC = styled.div`
  .rc-slider {
    margin-top: 8px;

    &-horizontal {
      padding: 0;
    }

    &-with-marks {
      min-height: 40px;
    }

    &-rail {
      border: 1px solid ${({ theme }) => theme.color.border.outline};
      border-radius: 4px;
      background: ${({ theme }) => theme.color.surface.variant};
    }

    &-rail,
    &-track {
      height: 6px;
    }

    &-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      opacity: 1;
      background: ${({ theme }) => theme.color.surface.baseline};

      border: 2px solid ${({ theme }) => theme.color.solid.selection};
      box-shadow: ${({ theme }) => theme.shadows.low};
      transition-property: background, box-shadow;
      transition-duration: 0.2s;

      &-dragging {
        background: ${({ theme }) => theme.color.solid.selection} !important;
        border-color: ${({ theme }) => theme.color.solid.selection} !important;
        box-shadow: 0 0 0 6px ${({ theme }) => theme.color.state.focused} !important;
      }
    }

    &-track {
      background-color: ${({ theme }) => theme.color.solid.selection};
    }

    &-mark {
      position: absolute;
      top: 18px;
      left: 0;
      width: 100%;
      font-size: 12px;
    }

    &-mark-text {
      position: absolute;
      top: 0px;
      left: 2px;

      display: inline-block;

      color: ${({ theme }) => theme.color.tint.tertiary};

      text-align: center;
      vertical-align: middle;
      cursor: pointer;

      &-active {
        color: ${({ theme }) => theme.color.tint.highlight};
      }
    }

    &-step {
      position: absolute;
      width: calc(100% - 4px);
      height: 4px;
      top: 1px;
      left: 2px;
      background: transparent;
      pointer-events: none;
    }

    &-dot {
      position: absolute;

      bottom: 0px;
      width: 4px;
      height: 4px;
      border: none;
      cursor: pointer;

      vertical-align: middle;
      background-color: ${({ theme }) => theme.color.border.outline};
      border-radius: 50%;

      &-active {
        background: transparent;
      }

      &-reverse {
        margin-right: -4px;
      }
    }

    &-disabled {
      opacity: 0.5;
    }
  }
`;
